var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"loading":_vm.loading},on:{"click":_vm.toggleMute}},'v-btn',_vm.$attrs,false),[_c('v-icon',{attrs:{"left":""}},[_vm._v(" "+_vm._s(_vm.participant.is_muted ? "mdi-account-voice" : "mdi-account-voice-off")+" ")]),_vm._v(" "+_vm._s(_vm.participant.is_muted ? _vm.$t("common.unmute") : _vm.$t("common.mute"))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }